export default __webpack_public_path__ + "bart_logo.c2a03c8c.png";